import { render, staticRenderFns } from "./UserZoneView.vue?vue&type=template&id=252b68ec&lang=html&"
import script from "./UserZoneView.vue?vue&type=script&lang=js&"
export * from "./UserZoneView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports